export const tabStyle = {
  PRIMARY: 'PRIMARY',
  SECONDARY: 'SECONDARY',
};
